import { Injectable, isDevMode } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class Logger {
	devMode = isDevMode();

	log(...message: unknown[]) {
		if (this.devMode) {
			console.log(message);
		} else {
			const messageString = message.join(" ");
		}
	}

	error(...message: unknown[]) {
		if (this.devMode) {
			console.error(message);
		} else {
			const messageString = message.join(" ");
		}
	}

	warn(...message: unknown[]) {
		if (this.devMode) {
			console.warn(message);
		} else {
			const messageString = message.join(" ");
		}
	}

	info(...message: unknown[]) {
		if (this.devMode) {
			console.info(message);
		} else {
			const messageString = message.join(" ");
		}
	}

	debug(...message: unknown[]) {
		if (this.devMode) {
			console.debug(message);
		} else {
			const messageString = message.join(" ");
		}
	}

	trace(...message: unknown[]) {
		if (this.devMode) {
			console.trace(message);
		} else {
			const messageString = message.join(" ");
		}
	}
}
